<template>
  <div class="animated fadeIn">
    <component-header
      title="Stock Points"
      @search-query="(val) => (search = val)"
      :isLoading="loading"
      @reload-data="getStockpointList"
      @create-press="createOffice"
    />

    <v-dialog v-model="loading" fullscreen full-width>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5)">
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <b-card class="card-wrap" border-variant="info">
      <!-- <b-row>
        <b-col md="12">
          <eb-button
            class="btn float-right mr-2"
            classic="mr-1 btn-primary"
            text="Create Stock Point"
            icon="fa fa-plus-circle mr-1"
            iconSide="left"
            @click="createOffice"
          ></eb-button>
        </b-col>
      </b-row> -->
      <div class="mt-3">
        <b-table
          :fields="partnerColumns"
          :items="partners"
          class="table-bordered table-sm"
          :dark="dark"
          :filter="search"
          :hover="hover"
          thead-class="header"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          show-empty
          ref="partners"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="name" slot-scope="data">
            <div class="table-row">{{ data.userName }}</div>
          </template>
          <template slot="action" slot-scope="data">
            <b-button
              size="sm"
              class="mr-2"
              variant="primary"
              @click="viewSubOffice(data.item)"
            >
              <i class="fa fa-eye"></i>
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentHeader";
export default {
  name: "viewattribute",
  components: {
    ebButton,
    ComponentHeader,
  },
  data() {
    return {
      loading: false,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      search: "",
      partner: {},
      sortBy: "createdAt",
      sortDesc: true,
      partnerColumns: [
        {
          key: "userName",
          sortable: true,
        },
        {
          key: "email",
        },
        {
          key: "phone",
        },
        {
          key: "action",
        },
      ],
    };
  },
  computed: {
    partners() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let partnerList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          if (obj.category == "STOCK_POINT") {
            let arrayObj = {
              _id: obj._id,
              userName: obj.authentication.userName,
              email: obj.authentication.email,
              phone: obj.authentication.phone,
              ...obj,
            };
            partnerList.push(arrayObj);
          }
        });
        return partnerList;
      } else {
        return [];
      }
    },
  },
  methods: {
    viewSubOffice(data) {
      this.$store.dispatch("partner/editPartnerData", data);
      this.$router.push("/suboffice-management/view");
    },
    createOffice() {
      this.$router.push("/suboffice-management/create");
    },
    async getStockpointList() {
      this.loading = true;
      await this.$store.dispatch("partner/fetchPartnersList").then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
          this.loading = false;
        }
        this.loading = false;
      });
    },
  },
  watch: {
    search(value) {
      this.currentPage = 1;
    },
  },
  async mounted() {
    let data = this.$store.getters["partner/GetPartnerList"];
    if (!data || !data.length) this.getStockpointList();
  },
};
</script>

<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
